import { useEffect, useState } from 'react';
import { useGetBilan_CabinetQuery } from 'actions/cabinet/queries';

const useBilanData = (dossier_id, exercice_id) => {
  const {
    data: bilanResponse,
    isLoading,
    error,
    refetch,
  } = useGetBilan_CabinetQuery(
    { dossier_id: dossier_id, exercice_id: exercice_id },
    { skip: !dossier_id || !exercice_id } // Ne pas exécuter la requête si dossier_id ou exercice_id est null/undefined
  );

  const [bilanData, setBilanData] = useState(null);
  const [lignesActif, setLignesActif] = useState([]);
  const [lignesPassif, setLignesPassif] = useState([]);
  const [totaux, setTotaux] = useState({
    actif_total: 0,
    passif_total: 0,
  });

  useEffect(() => {
    if (!isLoading && bilanResponse) {
      // Vérifier si la réponse est un objet valide
      if (typeof bilanResponse !== 'object' || Array.isArray(bilanResponse)) {
        console.error('Format de réponse invalide:', bilanResponse);
        setBilanData(null);
        return;
      }

      console.log('Bilan response reçu:', bilanResponse);
      setBilanData(bilanResponse);

      // Le backend renvoie lignes_actif et lignes_passif (BilanComptableDetailSerializer)
      // ou lignes (BilanComptableSerializer)
      const actifs = bilanResponse.lignes_actif || 
                     bilanResponse.lignes?.filter((ligne) => ligne.nature === 'actif') || 
                     [];
      const passifs = bilanResponse.lignes_passif || 
                      bilanResponse.lignes?.filter((ligne) => ligne.nature === 'passif') || 
                      [];

      console.log('Lignes actif extraites:', actifs.length);
      console.log('Lignes passif extraites:', passifs.length);

      setLignesActif(actifs);
      setLignesPassif(passifs);

      // Calculer les totaux avec gestion des valeurs nulles/indéfinies
      setTotaux({
        actif_total: bilanResponse.actif_total || 0,
        passif_total: bilanResponse.passif_total || 0,
        actif_brut_total: bilanResponse.actif_brut_total || 0,
        actif_amort_total: bilanResponse.actif_amort_total || 0,
        actif_total_n1: bilanResponse.actif_total_n1 || 0,
      });
    } else if (!isLoading && !bilanResponse) {
      // Aucune donnée reçue
      setBilanData(null);
      setLignesActif([]);
      setLignesPassif([]);
      setTotaux({
        actif_total: 0,
        passif_total: 0,
        actif_brut_total: 0,
        actif_amort_total: 0,
        actif_total_n1: 0,
      });
    }
  }, [isLoading, bilanResponse]);

  const getLigneByCode = (code, nature = 'actif') => {
    const lignes = nature === 'actif' ? lignesActif : lignesPassif;
    return lignes.find((ligne) => ligne.code_reference === code) || {
      montant_brut: 0,
      montant_amortissement: 0,
      montant_net: 0,
      montant_net_n1: 0
    };
  };

  return {
    bilanData,
    lignesActif,
    lignesPassif,
    totaux,
    isLoading,
    error,
    refetch,
    getLigneByCode,
  };
};

export default useBilanData;
